/* import __COLOCATED_TEMPLATE__ from './t-split.hbs'; */
var _dec, _dec2, _class, _class2, _descriptor, _class3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import { htmlSafe } from '@ember/template';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';

/**
## T Split

Allows for interpolating HTML into a template.

### Example

```example
@title Basic usage

@controller-properties
{
  // These are the segments you would get with the template
  // `Text before the link {{#link}}First text in the link {{#strong}}text in the strong{{/strong}}, final text in the link{/link}} text after the link`
  segments: [
    { text: 'Text before the link ' },
    {
      key: 'link',
      content: [
        { text: 'First text in the link ' },
        { key: 'strong', content: [{ text: 'text in the strong' }] },
        { text: ', final text in the link'}
      ]
    },
    { text: ' text after the link' }
  ]
}

@hbs
{{!-- Instead of using `split-segments`, you use use `#t-split key="key" options=(hash ...) as |segment|` --}}
{{#t-split/split-segments segments=segments as |segment|~}}
  {{~#if (eq segment.key "link")~}}
    <a href="squareup.com">
      {{~#segment.content as |innerSegment|~}}
        {{~#if (eq innerSegment.key "strong")~}}
          <strong>
            {{~innerSegment.content~}}
          </strong>
        {{~/if~}}
      {{~/segment.content~}}
    </a>
  {{~/if~}}
{{~/t-split/split-segments}}
```

### Parameters
@param {String} translationKey The translation key that identifies the template.
@param {Object} [options=undefined] The options that get used for the translation.
*/

function htmlSafeHelper(segment) {
  if (segment.content) {
    return {
      key: segment.key,
      content: segment.content.map(htmlSafeHelper)
    };
  } else {
    return {
      text: htmlSafe(segment.text)
    };
  }
}
let TSplit = (_dec = tagName(''), _dec2 = computed('i18n', 'translationKey', 'options'), _dec(_class = (_class2 = (_class3 = class TSplit extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "i18n", _descriptor, this);
  }
  get segments() {
    return this.i18n.tSplit(this.translationKey, this.options).map(htmlSafeHelper);
  }
}, _defineProperty(_class3, "positionalParams", ['translationKey', 'options']), _class3), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "segments", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "segments"), _class2.prototype), _class2)) || _class);
export { TSplit as default };